import React from 'react'
import { videoURLtoEmbed } from '../../admin/utils'

const EmbedVideoIframe = ({url, autoplay = false}) => {

  return (
    <iframe 
      src={videoURLtoEmbed(url, autoplay)} scrolling="no"
      style={{ border: '0px', width: '100%', height: '100%', display: 'block' }}
  />
  )
}

export default  EmbedVideoIframe